// extracted by mini-css-extract-plugin
export default {"container":"SearchPage_container__n-l5S","searchWord":"SearchPage_searchWord__trKz4","inner":"SearchPage_inner__AobBL","itemList":"SearchPage_itemList__KV6w1"};